import {useLocation, useNavigate} from "react-router-dom";
import {useEffect, useRef} from "react";
import {fetchAllowedRedirects, fetchAppStoreUrl, fetchPlayStoreUrl,} from "../api/authApi";
import {toast} from "react-toastify";
import LoadingSpinner from "./LoadingSpinner";

const DEVICE_TYPE = { ANDROID: "ANDROID", IOS: "IOS", OTHER: "OTHER" };

const isAndroid = () => /Android/i.test(navigator.userAgent);
const isIOS = () =>
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && (navigator).maxTouchPoints > 1);

function buildAndroidIntentFromScheme(schemeUrl: string, playUrl: string) {
  const u = new URL(schemeUrl);
  const hostPath = `${u.host}${u.pathname}${u.search}${u.hash}`;
  const scheme = u.protocol.replace(":", "");
  const pkg = new URL(playUrl).searchParams.get("id");
  const fb = encodeURIComponent(playUrl);
  return `intent://${hostPath}#Intent;scheme=${scheme};package=${pkg};S.browser_fallback_url=${fb};end`;
}

export default function MobileCallback() {
  const { search } = useLocation();
  const navigate = useNavigate();
  const ranRef = useRef(false);

  useEffect(() => {
    (async () => {
      try {
        const params = new URLSearchParams(search);
        const redirectUrl = params.get("redirect_url");

        if (!redirectUrl) {
          toast.error("Redirect URL not found", { autoClose: 5000, containerId: "Main" });
          return navigate("/login", { replace: true });
        }

        const allowed = await fetchAllowedRedirects();
        const base = redirectUrl.split("?")[0];
        const isAllowed = allowed.includes(base) || allowed.some(a => base.startsWith(a));
        if (!isAllowed) {
          toast.error("Invalid Redirect URL", { autoClose: 5000, containerId: "Main" });
          return navigate("/login", { replace: true });
        }

        if (ranRef.current) return; // StrictMode guard
        ranRef.current = true;

        if (/^https?:\/\//i.test(redirectUrl)) {
          const url = new URL(redirectUrl, window.location.origin);
          return window.location.replace(url.href);
        }

        const device = isAndroid() ? DEVICE_TYPE.ANDROID : isIOS() ? DEVICE_TYPE.IOS : DEVICE_TYPE.OTHER;
        if (device === DEVICE_TYPE.OTHER) {
          toast.error("Unsupported device", { autoClose: 5000, containerId: "Main" });
          return navigate("/login", { replace: true });
        }

        const start = Date.now();
        const appStoreUrl = await fetchAppStoreUrl();
        const playStoreUrl = await fetchPlayStoreUrl();

        if (device === DEVICE_TYPE.ANDROID) {
          window.location.href = buildAndroidIntentFromScheme(redirectUrl, playStoreUrl);
        } else {
          window.location.href = redirectUrl;
        }

        const delayMs = 5000;
        const guardMs = 900;
        const timer = window.setTimeout(() => {
          if (!document.hidden && Date.now() - start > guardMs) {
            window.location.replace(device === DEVICE_TYPE.IOS ? appStoreUrl : playStoreUrl);
          }
        }, delayMs);

        const cancel = () => { if (document.hidden) clearTimeout(timer); };
        document.addEventListener("visibilitychange", cancel, { once: true });
        window.addEventListener("pagehide", cancel, { once: true });

      } catch (e) {
        console.error(e);
        toast.error("Error occurred", { autoClose: 5000, containerId: "Main" });
        navigate("/login", { replace: true });
      }
    })();
  }, [search, navigate]);

  return (
      <div style={{ height: "100%", width: "100%", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
        <LoadingSpinner />
        <h4>Redirecting to Mobile app…</h4>
      </div>
  );
};
